import type { StoryNode } from '@/engine/types'

// 独立黄金样板只验证新区开场的节奏、对白与选择回响。所有节点均在
// golden-slice 内存沙盒运行，不接入正式序章，也不发放收藏、结局或存档奖励。
export const GOLDEN_SLICE_ENTRY = 'gs1-s1-opening'
export const GOLDEN_SLICE_EXIT = 'gs1-exit'

// 第一场“跟朋友一起玩”的动机会在被换下时额外触发朋友的安置承诺；
// 认真冲榜沿用明确的前三十门槛，打听祈福则留到第七场消费 4999 伏笔。
const thirdSceneOpeningCallback: StoryNode['next'] = {
  cases: [{ when: { type: 'variable', key: 'gs1OpeningMotive', operator: 'eq', value: 'together' }, next: 'gs1-s3-together-motive' }],
  fallback: 'gs1-s3-common',
}

export const goldenSliceNodes: StoryNode[] = [
  // ───────────────────────── 第一场：这次认真玩 ─────────────────────────
  {
    id: GOLDEN_SLICE_ENTRY,
    chapter: 'prologue',
    actLabel: '黄金样板 · 第一场',
    date: '2026-07-16',
    title: '这次认真玩',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '在吗？4945 明晚开，要不要一起？',
    background: 'invitation',
    music: 'duskLogin',
    historical: 'fictional',
    next: 'gs1-s1-context',
  },
  {
    id: 'gs1-s1-context',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第一场',
    date: '2026-07-16',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '暑假没事干，正好几个人都说要来。这次不乱玩了，开服就冲榜，先把一组占住。祈福带队，奶瓶也来。你来不来？',
    background: 'invitation',
    music: 'duskLogin',
    historical: 'fictional',
    next: 'gs1-s1-choice',
  },
  {
    id: 'gs1-s1-choice',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第一场',
    date: '2026-07-16',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你来不来？来的话我给你留个队伍位置。',
    background: 'invitation',
    music: 'duskLogin',
    historical: 'fictional',
    choices: [
      {
        id: 'gs1-opening-serious',
        label: '“老区没玩好，这次新区我要认真地玩一下。”',
        tone: 'bold',
        effects: [{ type: 'variable', key: 'gs1OpeningMotive', value: 'serious' }],
        next: 'gs1-s1-serious',
      },
      {
        id: 'gs1-opening-together',
        label: '“开新区我也要来，老区太无聊了。”',
        tone: 'warm',
        effects: [{ type: 'variable', key: 'gs1OpeningMotive', value: 'together' }],
        next: 'gs1-s1-together',
      },
      {
        id: 'gs1-opening-curious',
        label: '“首领叫祈福吗？他和你关系怎么样？”',
        tone: 'calm',
        effects: [{ type: 'variable', key: 'gs1OpeningMotive', value: 'curious' }],
        next: 'gs1-s1-curious',
      },
    ],
  },
  {
    id: 'gs1-s1-serious',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第一场',
    date: '2026-07-16',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '好，这次我们一起冲击本服排行榜，冲个一组。开服别迟到啊。',
    background: 'invitation',
    historical: 'fictional',
    next: 'gs1-s1-invite',
  },
  {
    id: 'gs1-s1-together',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第一场',
    date: '2026-07-16',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '好，我们一起开新区，正好缺人呢。你别又玩两天就跑。',
    background: 'invitation',
    historical: 'fictional',
    next: 'gs1-s1-invite',
  },
  {
    id: 'gs1-s1-curious',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第一场',
    date: '2026-07-16',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '他是我老区的兄弟，这次正好暑假，就一起开区了。人还可以，人不错，当首领没啥问题。不过他玩不了多长时间，等 4999 区开服就走了。',
    background: 'invitation',
    historical: 'fictional',
    next: 'gs1-s1-invite',
  },
  {
    id: 'gs1-s1-invite',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第一场',
    date: '2026-07-17',
    location: '开服队伍',
    mode: 'system',
    speaker: 'system',
    text: '老朋友邀请你加入队伍。队伍成员：祈福、顶级奶瓶、老朋友、你。',
    background: 'login',
    sound: 'notice',
    historical: 'fictional',
    next: 'gs1-s1-qifu',
  },
  {
    id: 'gs1-s1-qifu',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第一场',
    date: '2026-07-17',
    location: '开服队伍',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '人齐了就开。',
    background: 'login',
    music: 'groupChat',
    historical: 'fictional',
    next: 'gs1-s2-mistake',
  },

  // ───────────────────────── 第二场：开服第一晚 ─────────────────────────
  {
    id: 'gs1-s2-mistake',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第二场',
    date: '2026-07-17',
    title: '开服第一晚',
    location: '开服队伍',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '先别强化那个蓝装，过两级就换了。……你已经全点了？行，当我没问。',
    background: 'login',
    music: 'groupChat',
    historical: 'fictional',
    next: 'gs1-s2-ranking',
  },
  {
    id: 'gs1-s2-ranking',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第二场',
    date: '2026-07-17',
    location: '战力排行榜',
    mode: 'system',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '祈福第4，我第9，老朋友第12。你46。资源点错了，支线少清两组，免费体力也没领。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s2-slot',
  },
  {
    id: 'gs1-s2-slot',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第二场',
    date: '2026-07-17',
    location: '群雄逐鹿 · 成员列表',
    mode: 'system',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '一组还差一个学员，先拉进来吧。先挂一晚，明早榜单刷新，前三十留下，三十名以后换人。都一样。',
    background: 'organization',
    sound: 'notice',
    historical: 'fictional',
    onEnter: [{ type: 'route', route: 'org1', organization: 'org1', role: 'member' }],
    next: 'gs1-s2-choice',
  },
  {
    id: 'gs1-s2-choice',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第二场',
    date: '2026-07-17',
    location: '开服队伍',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你现在排第四十六，今晚准备怎么追？我继续带你清任务，或者你问奶瓶怎么提最划算。',
    background: 'organization',
    historical: 'fictional',
    choices: [
      {
        id: 'gs1-night-grind',
        label: '“你先别下，带我把剩下的任务清完。”',
        tone: 'warm',
        effects: [{ type: 'variable', key: 'gs1NightPlan', value: 'grind' }],
        next: 'gs1-s2-grind',
      },
      {
        id: 'gs1-night-guide',
        label: '“我不乱点了，你告诉我先升哪个最划算。”',
        tone: 'calm',
        effects: [{ type: 'variable', key: 'gs1NightPlan', value: 'guide' }],
        next: 'gs1-s2-guide',
      },
    ],
  },
  {
    id: 'gs1-s2-grind',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第二场',
    date: '2026-07-17',
    location: '开服队伍',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '行，我主线打完了，回来带你补。为了带你，我都快掉出前十了。你明天别被换下去，就是最大的补偿。',
    background: 'login',
    historical: 'fictional',
    next: 'gs1-s2-close',
  },
  {
    id: 'gs1-s2-guide',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第二场',
    date: '2026-07-17',
    location: '顶级奶瓶 · 私聊',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '体力、支线、装备突破，按这个顺序。紫装以下别继续强化，金币留着。攻略给你了，榜得自己打。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s2-close',
  },
  {
    id: 'gs1-s2-close',
    chapter: 'prologue',
    actLabel: '黄金样板 · 第二场',
    date: '2026-07-17',
    location: '战力排行榜',
    mode: 'system',
    speaker: 'system',
    text: '当前战力排名：第34名。距离结算还有六小时，候补玩家已升至第31名。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s3-refresh',
  },

  // ───────────────────────── 第三场：榜单刷新 ─────────────────────────
  {
    id: 'gs1-s3-refresh',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    title: '榜单刷新',
    location: '战力排行榜',
    mode: 'system',
    speaker: 'system',
    text: '当前战力排名：第37名。你已离开组织「群雄逐鹿」，昨晚的候补进入学员栏。',
    background: 'organization',
    sound: 'warning',
    historical: 'fictional',
    next: {
      cases: [{ when: { type: 'variable', key: 'gs1NightPlan', operator: 'eq', value: 'guide' }, next: 'gs1-s3-guide-callback' }],
      fallback: 'gs1-s3-grind-callback',
    },
  },
  {
    id: 'gs1-s3-grind-callback',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '夜里那帮人都没睡，你下线后又被超了。你已经追不少了，别急。',
    background: 'organization',
    historical: 'fictional',
    next: thirdSceneOpeningCallback,
  },
  {
    id: 'gs1-s3-guide-callback',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    location: '顶级奶瓶 · 私聊',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '养成顺序没问题，差的是开服前两天的时间和资源。榜单在这，我不能因为攻略是我发的就不换。',
    background: 'organization',
    historical: 'fictional',
    next: thirdSceneOpeningCallback,
  },
  {
    id: 'gs1-s3-together-motive',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '本来说好一起开新区，结果先把你一个人留外面了。这次我负责给你找个有人带的地方，别因为这个又不玩了。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s3-common',
  },
  {
    id: 'gs1-s3-common',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你的战力太低了，一组要排行榜前三十的。你得去后面的组织提一下战力，再回来吧。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s3-choice',
  },
  {
    id: 'gs1-s3-choice',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '一组这边暂时没位置了。你接下来怎么打算？',
    background: 'organization',
    historical: 'fictional',
    choices: [
      {
        id: 'gs1-kick-return',
        label: '“先找个后面的组织，战力到了我再回来。”',
        tone: 'bold',
        effects: [{ type: 'variable', key: 'gs1AfterKick', value: 'return' }],
        next: 'gs1-s3-return',
      },
      {
        id: 'gs1-kick-together',
        label: '“给我找个有人带的就行。”',
        tone: 'warm',
        effects: [{ type: 'variable', key: 'gs1AfterKick', value: 'together' }],
        next: 'gs1-s3-together',
      },
      {
        id: 'gs1-kick-ask',
        label: '“你帮我问问祈福，能不能再给一天？”',
        tone: 'calm',
        effects: [{ type: 'variable', key: 'gs1AfterKick', value: 'ask' }],
        next: 'gs1-s3-ask',
      },
    ],
  },
  {
    id: 'gs1-s3-return',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '这就对了。我问问夏娜，她那边今天还缺人。我会说你以后可能回来，但你别进门第一句就讲这个。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s3-shana',
  },
  {
    id: 'gs1-s3-together',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你别退游啊。这次是我没安排好。我问问夏娜，她那边活动有人带。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s3-shana',
  },
  {
    id: 'gs1-s3-ask',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    location: '祈福 · 私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '不是针对你。今天给你，明天就得给别人。榜进前三十再找奶瓶。先去别的组把资源拿了，别因为这个不玩。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s3-shana',
  },
  {
    id: 'gs1-s3-shana',
    chapter: 'act1',
    actLabel: '黄金样板 · 第三场',
    date: '2026-07-18',
    location: '灼眼の夏娜 · 私聊',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '他说你今天还没领组织奖励。先进来，别浪费。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s4-entry',
  },

  // ───────────────────────── 第四场：先把今天的奖励领了 ─────────────────────────
  {
    id: 'gs1-s4-entry',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    title: '先把今天的奖励领了',
    location: '夏娜所在组织',
    mode: 'system',
    speaker: 'system',
    text: '你的组织申请已通过。当天组织奖励将在四十分钟后结算。',
    background: 'organization',
    sound: 'notice',
    historical: 'fictional',
    onEnter: [{ type: 'route', route: 'org2', organization: 'org2', role: 'member' }],
    next: 'gs1-s4-saoji',
  },
  {
    id: 'gs1-s4-saoji',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    location: '活动队伍',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '从一组那边来的？那跟我差不多，我比你多待几天。先打，马上结算了。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s4-fail',
  },
  {
    id: 'gs1-s4-fail',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    location: '活动队伍',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '你站太前了，这个技能会点最远的人。现在告诉了，再来。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s4-reward',
  },
  {
    id: 'gs1-s4-reward',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    location: '活动奖励',
    mode: 'system',
    speaker: 'system',
    text: '第二次挑战通过。获得组织贡献、强化材料和金币。',
    background: 'rewardHall',
    sound: 'notice',
    historical: 'fictional',
    next: 'gs1-s4-help',
  },
  {
    id: 'gs1-s4-help',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    location: '活动队伍',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '你那个紫装别分解，材料能返。老区也没怎么玩过吧？没事，我刚来这边的时候也乱点。攻略发你了。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s4-choice',
  },
  {
    id: 'gs1-s4-choice',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    location: '夏娜所在组织',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '先问一句，你是来这里提战力的，还是先跟我们一起玩？',
    background: 'organization',
    historical: 'fictional',
    choices: [
      {
        id: 'gs1-stay-transparent',
        label: '“我先在这里提战力，进前三十可能还会回一组。”',
        tone: 'calm',
        effects: [{ type: 'variable', key: 'gs1StayPosture', value: 'transparent' }],
        next: 'gs1-s4-transparent',
      },
      {
        id: 'gs1-stay-quiet',
        label: '“我刚来，先跟你们把活动打完吧。”',
        tone: 'warm',
        effects: [{ type: 'variable', key: 'gs1StayPosture', value: 'quiet' }],
        next: 'gs1-s4-quiet',
      },
    ],
  },
  {
    id: 'gs1-s4-transparent',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    location: '夏娜所在组织',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '可以，先把今天该拿的拿了。以后去哪，等你真能选的时候再说。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s4-rank',
  },
  {
    id: 'gs1-s4-quiet',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    location: '夏娜所在组织',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '行，明天晚上还是这个点。我先把你排进活动名单，来不了提前说。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s4-rank',
  },
  {
    id: 'gs1-s4-rank',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    location: '战力排行榜',
    mode: 'system',
    speaker: 'system',
    text: '组织奖励已领取。当前战力排名：第33名。',
    background: 'rewardHall',
    historical: 'fictional',
    next: 'gs1-s4-enemy',
  },
  {
    id: 'gs1-s4-enemy',
    chapter: 'act2',
    actLabel: '黄金样板 · 第四场',
    date: '2026-07-18',
    location: '4945 · 世界频道',
    mode: 'system',
    speaker: 'system',
    text: '与世界为敌——我是骚鸡。世界频道开始重复刷出他的名字和一张被截断的聊天记录。',
    background: 'worldChat',
    music: 'worldEnemy',
    sound: 'warning',
    historical: 'adapted',
    next: 'gs1-s5-world',
  },

  // ───────────────────────── 第五场：他现在在我们组 ─────────────────────────
  {
    id: 'gs1-s5-world',
    chapter: 'act3',
    actLabel: '黄金样板 · 第五场',
    date: '2026-07-18',
    title: '他现在在我们组',
    location: '4945 · 世界频道',
    mode: 'chat',
    speaker: 'crowd',
    text: '一组不要的也有人收啊？这种人还有组要？自己看他说过什么。',
    background: 'worldChat',
    music: 'worldEnemy',
    historical: 'adapted',
    next: 'gs1-s5-shana',
  },
  {
    id: 'gs1-s5-shana',
    chapter: 'act3',
    actLabel: '黄金样板 · 第五场',
    date: '2026-07-18',
    location: '夏娜所在组织',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '群里的人先别骂回去。有完整记录的发群文件，别跟着世界频道刷。',
    background: 'worldChat',
    historical: 'fictional',
    next: 'gs1-s5-mentor',
  },
  {
    id: 'gs1-s5-mentor',
    chapter: 'act3',
    actLabel: '黄金样板 · 第五场',
    date: '2026-07-18',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你先别说话，祈福和奶瓶在处理。一组那边最烦别人插手。',
    background: 'worldChat',
    historical: 'fictional',
    next: 'gs1-s5-qifu',
  },
  {
    id: 'gs1-s5-qifu',
    chapter: 'act3',
    actLabel: '黄金样板 · 第五场',
    date: '2026-07-18',
    location: '祈福 · 私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '想回来就别卷进去，继续提你的战力。',
    background: 'worldChat',
    historical: 'fictional',
    next: 'gs1-s5-choice',
  },
  {
    id: 'gs1-s5-choice',
    chapter: 'act3',
    actLabel: '黄金样板 · 第五场',
    date: '2026-07-18',
    location: '夏娜所在组织',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '真不用替我说话，打你们自己的。',
    background: 'worldChat',
    historical: 'adapted',
    choices: [
      {
        id: 'gs1-world-silent',
        label: '“我先不在公频说，把完整记录发给老朋友。”',
        tone: 'calm',
        effects: [{ type: 'variable', key: 'gs1WorldStance', value: 'silent' }],
        next: 'gs1-s6-silent-mentor',
      },
      {
        id: 'gs1-world-public',
        label: '“他现在在我们组。有事把记录发全，别一直刷名字。”',
        tone: 'bold',
        effects: [{ type: 'variable', key: 'gs1WorldStance', value: 'public' }],
        next: 'gs1-s6-public-shana',
      },
    ],
  },

  // ───────────────────────── 第六场：从这一句开始 ─────────────────────────
  {
    id: 'gs1-s6-silent-mentor',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-19',
    title: '还想回去的人',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '祈福看完了，说会让一组的人别再转发。你这样就行，别影响你自己。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'gs1-s6-silent-bottle',
  },
  {
    id: 'gs1-s6-silent-bottle',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-19',
    location: '顶级奶瓶 · 私聊',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '记录收到了。你战力进前三十，有位置就按正常申请走。你没在公频掺和，为什么不能回？看榜、看空位。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'gs1-s6-silent-saoji',
  },
  {
    id: 'gs1-s6-silent-saoji',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-19',
    location: '我是骚鸡 · 私聊',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '任务清完了？懂，你还要回一组。',
    background: 'nightMessage',
    historical: 'fictional',
    next: {
      cases: [{ when: { type: 'variable', key: 'gs1StayPosture', operator: 'eq', value: 'transparent' }, next: 'gs1-s6-silent-transparent' }],
      fallback: 'gs1-s6-silent-quiet',
    },
  },
  {
    id: 'gs1-s6-silent-transparent',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-19',
    location: '我是骚鸡 · 私聊',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '你进来的时候就说过，所以我没怪你。攻略还有哪不懂就问，回不回是一回事。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'gs1-s6-silent-rank',
  },
  {
    id: 'gs1-s6-silent-quiet',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-19',
    location: '我是骚鸡 · 私聊',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '没决定就先别解释了。等你真进前三十再说吧。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'gs1-s6-silent-rank',
  },
  {
    id: 'gs1-s6-silent-rank',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-20',
    location: '战力排行榜',
    mode: 'system',
    speaker: 'system',
    text: '你仍在普通活动队，战力继续上涨。当前排名：第29名。一组同时空出一个位置。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s7-entry',
  },
  {
    id: 'gs1-s6-public-shana',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-19',
    title: '现在是我们的人',
    location: '4945 · 世界频道',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '这句话算我们组说的。有记录发全，没记录就别一直挂名字。下次发之前先在群里说一声，不是不能说，是别一个人扛。',
    background: 'worldChat',
    historical: 'fictional',
    next: 'gs1-s6-public-saoji',
  },
  {
    id: 'gs1-s6-public-saoji',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-19',
    location: '我是骚鸡 · 私聊',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '前后记录都发你了。你刚来两天，没必要替我说这句。但我记住了。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'gs1-s6-public-qifu',
  },
  {
    id: 'gs1-s6-public-qifu',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-19',
    location: '祈福 · 私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '你替现在的组说话，没问题。以后就先按他们的人算。进前三十可以正常申请，但别再让你朋友替你留位置。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'gs1-s6-public-mentor',
  },
  {
    id: 'gs1-s6-public-mentor',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-19',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你这下真站那边了？很多时候就是从一句话开始的。以后要塞碰上，我们可能就在对面了。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'gs1-s6-public-rank',
  },
  {
    id: 'gs1-s6-public-rank',
    chapter: 'act4',
    actLabel: '黄金样板 · 第六场',
    date: '2026-07-20',
    location: '战力排行榜',
    mode: 'system',
    speaker: 'system',
    text: '你被排进夏娜与骚鸡的活动队。当前战力排名：第29名。一组同时空出一个位置，但你的候补备注已被删除。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s7-entry',
  },

  // ───────────────────────── 第七场：榜到了 ─────────────────────────
  {
    id: 'gs1-s7-entry',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    title: '榜到了',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '可以啊，真让你打回来了。一组空了一位，前三十能申请。你还回不回？',
    background: 'organization',
    music: 'afterOnline',
    historical: 'fictional',
    next: {
      cases: [{ when: { type: 'variable', key: 'gs1OpeningMotive', operator: 'eq', value: 'curious' }, next: 'gs1-s7-4999' }],
      fallback: 'gs1-s7-current-team',
    },
  },
  {
    id: 'gs1-s7-4999',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '祈福 · 私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '你问4999开服以后怎么办？我走是我的事。到时候这个组能不能留住，是留下来的人决定。先把4945玩好。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s7-current-team',
  },
  {
    id: 'gs1-s7-current-team',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '夏娜所在组织',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '二十九名，还挺快。战力有一半是我们带出来的？那一半也算你的，你自己没上线谁也带不动。',
    background: 'organization',
    historical: 'fictional',
    next: {
      cases: [{ when: { type: 'variable', key: 'gs1WorldStance', operator: 'eq', value: 'public' }, next: 'gs1-s7-public-offer' }],
      fallback: 'gs1-s7-silent-offer',
    },
  },
  {
    id: 'gs1-s7-silent-offer',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '顶级奶瓶 · 私聊',
    mode: 'chat',
    speaker: 'bottle',
    portrait: 'bottle',
    text: '榜二十九，符合。今晚前确认，过时继续给下一名。这次不用祈福特批，榜和空位都够。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s7-choice',
  },
  {
    id: 'gs1-s7-public-offer',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '祈福 · 私聊',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '榜到了，说明你确实认真玩了。要回来就按正常申请；要留下，也别拿一组当退路。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s7-choice',
  },
  {
    id: 'gs1-s7-choice',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '夏娜所在组织',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '一组的申请就在那边，今晚活动名单也给你留着。你自己选。',
    background: 'organization',
    historical: 'fictional',
    choices: [
      {
        id: 'gs1-final-return',
        label: '“我本来就是为了冲一组来的。现在够了，我想回去试试。”',
        tone: 'bold',
        effects: [{ type: 'variable', key: 'gs1FinalChoice', value: 'return' }],
        next: {
          cases: [{ when: { type: 'variable', key: 'gs1WorldStance', operator: 'eq', value: 'public' }, next: 'gs1-s7-return-queue' }],
          fallback: 'gs1-s7-return-accepted',
        },
      },
      {
        id: 'gs1-final-stay',
        label: '“战力是你们陪我提起来的。我不回去了。”',
        tone: 'warm',
        effects: [{ type: 'variable', key: 'gs1FinalChoice', value: 'stay' }],
        next: 'gs1-s7-stay',
      },
    ],
  },
  {
    id: 'gs1-s7-return-accepted',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '群雄逐鹿 · 成员列表',
    mode: 'system',
    speaker: 'system',
    text: '你的组织申请已通过。你已加入组织「群雄逐鹿」，职位：学员。',
    background: 'organization',
    sound: 'notice',
    historical: 'fictional',
    onEnter: [{ type: 'route', route: 'org1', organization: 'org1', role: 'member' }],
    next: 'gs1-s7-return-mentor',
  },
  {
    id: 'gs1-s7-return-mentor',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '开服队伍',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '欢迎回来。这次不是我塞你进来的，榜二十九，自己打的。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s7-end-qifu',
  },
  {
    id: 'gs1-s7-end-qifu',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '开服队伍',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '都到了？人齐了，开了。',
    background: 'organization',
    music: 'groupChat',
    historical: 'fictional',
    next: GOLDEN_SLICE_EXIT,
  },
  {
    id: 'gs1-s7-return-queue',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '组织申请界面',
    mode: 'system',
    speaker: 'system',
    text: '申请已提交，当前排队：第2位。公开表态的后果没有因为战力达标而消失。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s7-queue-shana',
  },
  {
    id: 'gs1-s7-queue-shana',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '夏娜所在组织',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '今晚活动你照常来。申请通过之前，你还在我们名单上。申请的事打完再看，先别挂机。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s7-end-saoji',
  },
  {
    id: 'gs1-s7-end-saoji',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '活动队伍',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '真通过了记得说一声，别突然人没了。现在人齐了，开了。',
    background: 'organization',
    music: 'groupChat',
    historical: 'fictional',
    next: GOLDEN_SLICE_EXIT,
  },
  {
    id: 'gs1-s7-stay',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '夏娜所在组织',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '想好了？那以后别说暂住了。下一场活动，算你一个。',
    background: 'organization',
    historical: 'fictional',
    onEnter: [{ type: 'route', route: 'org2', organization: 'org2', role: 'member' }],
    next: 'gs1-s7-stay-mentor',
  },
  {
    id: 'gs1-s7-stay-mentor',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '老朋友 · 私聊',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '真不回了？行，要塞对面见，输了别找我哭。',
    background: 'organization',
    historical: 'fictional',
    next: 'gs1-s7-end-shana',
  },
  {
    id: 'gs1-s7-end-shana',
    chapter: 'epilogue',
    actLabel: '黄金样板 · 第七场',
    date: '2026-07-20',
    location: '活动队伍',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '都准备好了？人齐了，开了。',
    background: 'organization',
    music: 'groupChat',
    historical: 'fictional',
    next: GOLDEN_SLICE_EXIT,
  },
  {
    id: GOLDEN_SLICE_EXIT,
    chapter: 'epilogue',
    actLabel: '黄金样板 · 完成',
    date: '2026-07-20',
    location: '试玩结束',
    mode: 'system',
    speaker: 'system',
    text: '黄金样板试玩完成。',
    background: 'ending',
    historical: 'fictional',
  },
]
